(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["handcream-signup"] && !Shopify.designMode) return;
  try {
    
if (!window.ycMemphisMotionBound) {
  window.ycMemphisMotionBound = true;
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.yc-hc__motion');
    if (!button) return;
    const visual = button.closest('.yc-hc__memphis');
    const paused = visual.toggleAttribute('data-paused');
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? 'Afspil konfettianimation' : 'Sæt konfettianimation på pause');
    button.textContent = paused ? '▶' : 'Ⅱ';
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
